export default {
	id: "macbook-pro-2016",
	title: "Macbook Pro 2016",
	company: "Apple",
	styles: [
		{
			title: "normal",
			pos: ["6.5%", "11.7%", "11%", "11.7%"],
			colors: [
				{
					title: "Silver",
					hex: "#D5D2CF",
					img: require("./original/silver.png")
				},
				{
					title: "Space Grey",
					hex: "#9D9D9D",
					img: require("./original/space-grey.png")
				}
			]
		},
		{
			title: "flat",
			pos: ["7%", "11%", "13%", "11%"],
			colors: [
				{title: "Silver", hex: "#D5D2CF", img: require("./flat/silver.svg")},
				{
					title: "Space Grey",
					hex: "#9D9D9D",
					img: require("./flat/space-grey.svg")
				}
			]
		}
	]
};
